namespace app.services.oauth {
  export abstract class BaseOAuthService {
    private httpService;
    private configService;

    protected constructor(httpService, configService) {
      this.httpService = httpService;
      this.configService = configService;
    }

    public async getAuthorizationUrl() {
      const response = await this.httpService.$http({
        method: 'GET',
        url: this.configService.getServerBaseUrl() + this.getAuthUrlRelativeUri()
      });

      return response.data;
    }

    public async getAuthorizationToken(state: string, code: string, redirectBaseUrl: string) {
      const response = await this.httpService.$http({
        method: 'GET',
        url: this.configService.getServerBaseUrl() + this.getAuthTokenRelativeUri(),
        params: {state: state, code: code}
      });

      return response.data;
    }

    protected abstract getAuthUrlRelativeUri(): string;

    protected abstract getAuthTokenRelativeUri(): string;
  }
}

// ES6 export for modules that import BaseOAuthService
export const BaseOAuthService = app.services.oauth.BaseOAuthService;
